import React, { useContext, useEffect, useReducer, useRef, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { fetchSinToken } from '../helpers/fetch';

import { AuthContext } from '../reducers/auth/AuthContext';
import { CompanyContext } from '../reducers/CompanyContext';
import { CompanyReducer } from '../reducers/CompanyReducer';
import { SectionContext } from '../reducers/sections/sectionsContext';
import { SectionsReducer } from '../reducers/sections/SectionsReducer';
import { types } from '../types/types';

import CompanyScreen from '../components/company/CompanyScreen';
import DashboardScreen from '../components/DashboardScreen/DashboardScreen';
import { DashboardNav } from '../components/_ui/DashboardNav/DashboardNav';
import { SectionScreen } from '../components/sections/SectionScreen';
import { AddSection } from '../components/sections/AddSection';
import LoginScreen from '../components/auth/LoginScreen/LoginScreen';
import AllSections from '../components/sections/AllSections';
import MenuScreen from '../components/menu/MenuScreen/MenuScreen';
import Carta from '../components/menu/Carta/Carta';

const AppRouter = () => {
	const isMounted = useRef(true);
	const { user } = useContext(AuthContext);
	const [company, dispatchCompany] = useReducer(CompanyReducer, {});
	const [sections, dispatchSections] = useReducer(SectionsReducer, {});

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	});

	useEffect(() => {
		if (isMounted.current) {
			fetchSinToken(`sections`)
				.then((data) => data.json())
				.then((data) => dispatchSections({ type: types.getSections, payload: data.sections }))
				.catch((err) => new Error(err));
			fetchSinToken(`companies`)
				.then((data) => data.json())
				.then((data) => dispatchCompany({ type: types.getCompany, payload: data.company[0] }))
				.catch((err) => new Error(err));
		}
	}, []);

	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);


	return (
		<Router>
			<div>
				{ user.token ? (
					<CompanyContext.Provider value={ { company, dispatchCompany } }>
						<SectionContext.Provider value={ { sections, dispatchSections } }>

							<div className='dashboard-container'>
								<DashboardNav handleShow={ handleShow } />

								<main>
									<Switch>
										<Route exact path='/sanroque' component={ DashboardScreen } />
										<Route exact path='/sanroque/empresa' component={ CompanyScreen } />
										<Route exact path='/sanroque/carta' component={ Carta } />
										<Route exact path='/sanroque/menu' component={ MenuScreen } />
										<Route exact path='/sanroque/seccion' component={ AllSections } />
										<Route exact path='/sanroque/seccion/:id' component={ (props) => <SectionScreen { ...props } /> } />
										<Redirect to='/sanroque' />
									</Switch>

									<Modal size='xl' centered show={ show } onHide={ handleClose }>
										<Modal.Header closeButton>
											<h4>Añadir Sección a la web</h4>
										</Modal.Header>
										<Modal.Body>
											<AddSection handleClose={ handleClose } />
										</Modal.Body>
									</Modal>
								</main>
							</div>
						</SectionContext.Provider>
					</CompanyContext.Provider>
				) : (
					<section>
						<main className='login-container'>
							<figure>
								<img src={ process.env.REACT_APP_COMPANY_LOGO } alt="" />
							</figure>
							<Switch>
								<Route exact path='/' component={ LoginScreen } />
								<Redirect to='/' />
							</Switch>
							<div className="copyright">
								<small>&copy; Restaurante San Roque</small>
							</div>
						</main>
					</section>
				) }
			</div>
		</Router>
	);
};

export default AppRouter;
